import { Component, AfterViewInit, OnInit, OnDestroy, NgZone, ViewChild, ChangeDetectorRef, } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { AltaTecnicaDiagnosticaComponent } from './tecnicasdiagnosticasdetalle/altatecnicasdiagnosticas/altatecnicasdiagnosticas.component';

import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
  TdDialogService,
} from '@covalent/core';

import { TecnicaDiagnostica } from '../../../models';

import { TecnicasDiagnosticasService, LoginService, } from '../../../services/';

@Component({
  selector: 'qs-tecnicadiagnosticas',
  templateUrl: './tecnicasdiagnosticas.component.html',
  styleUrls: ['./tecnicasdiagnosticas.component.scss'],
  providers: [TecnicasDiagnosticasService],
})

export class TecnicasDiagnosticasComponent implements AfterViewInit, OnInit, OnDestroy {

  @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;

  public idValoracion: string;
  public idPaciente: string;
  public visita: string;
  public tecnicasDiagnosticas: TecnicaDiagnostica[];
  public valoraciones: any[];

  public isSmallScreen: boolean = false;
  public _querySubscription: Subscription;

  // ITDdDataTableComponent
  // Columnas
  public columnsAll: ITdDataTableColumn[] = [
    { name: 'id', label: 'Id', sortable: false, hidden: true },
    { name: 'idTecnica', label: 'IdTecnica', sortable: false, hidden: true },
    { name: 'mtecnica', label: 'Técnica', tooltip: 'Técnica Terapéutica', sortable: true },
    { name: 'idValoracion', label: 'IdValoracion', hidden: true },
    { name: 'fechaIndicacion', label: 'Indicación', tooltip: 'Fecha de Indicación', sortable: true, hidden: false },
    { name: 'fechaRealizacion', label: 'Realización', tooltip: 'Fecha de Realización', sortable: true, hidden: false },
    { name: 'dnimedIndicacion', label: 'DniMedIndicación', sortable: false, hidden: true },
    { name: 'expediente', label: 'Expediente', sortable: false, hidden: true },
    { name: 'texto', label: 'Texto', sortable: false, hidden: true },
    { name: 'viaAdministracion', label: 'viaAdministracion', sortable: false, hidden: true },
    { name: 'numVisitaIndicacion', label: 'numVisitaIndicacion', sortable: false, hidden: true },
    { name: 'numVisitaRealizacion', label: 'numVisitaRealizacion', sortable: false, hidden: true },
  ];

  public columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  public filteredData: any[] = [];
  public filteredDataTotal: number;

  // Propiedades
  public clickable: boolean = true;
  public selectable: boolean = false;
  public sortable: boolean = true;
  public sortBy: string = 'id';
  public sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  public searchTerm: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    public media: TdMediaService,
    private _tecnicaDiagnosticasService: TecnicasDiagnosticasService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Técnicas diagnósticas');
    this.watchScreen();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.visita = this._loginService.consulta.visita;
    this.loadTecnicasDiagnosticas();
    this._changeDetectorRef.detectChanges();
  }

  loadTecnicasDiagnosticas(): void {
    this._loadingService.register('tecnicasdiagnosticas.load');
    this._tecnicaDiagnosticasService.obtenerTecnicasDiagnosticas(this.idPaciente, this.visita).subscribe((res: any) => {
      if (res.error !== undefined) {
        this._loginService.mostrarMensaje('Error obteniendo técnicas diagnósticas.', 'OK', 6000);
        this._loadingService.resolve('tecnicasdiagnosticas.load');
      } else {
        this.tecnicasDiagnosticas = res.respuesta.tecnicas || [];
        this.valoraciones = res.respuesta.valoraciones;
        this._loginService.transient = this.valoraciones;
        if (this.valoraciones.length > 0) {
          this.idValoracion = this.valoraciones[0].id;
        }
        this.filteredData = this.tecnicasDiagnosticas;
        this.filteredDataTotal = this.tecnicasDiagnosticas.length;
        this._loadingService.resolve('tecnicasdiagnosticas.load');
      }
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo técnicas diagnósticas.', 'OK', 6000);
      this._loadingService.resolve('tecnicasdiagnosticas.load');
    });
  }

  ngOnInit(): void {
    this.watchScreen();
  }

  /**
   * watchScreen
   * Observable de cambio de resolució. Oculta o muestra columnas
   */
  watchScreen(): void {
    this._querySubscription = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.columns[0].hidden = true;
          // this.tableComponent.refresh();
        } else {
          // Mostramos columnas
          this.columns[0].hidden = false;
          // this.tableComponent.refresh();
        }
      });
    });
  }

  /**
   * openDetail: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetail(tecnica: any): void {
    let dialogRef: any = this._dialogService.open(AltaTecnicaDiagnosticaComponent, {
      data: tecnica,
      width: '50%',
      role: 'dialog',
    });
    dialogRef.componentInstance.tecnica = tecnica;
    dialogRef.componentInstance.mode = 'edit';
    dialogRef.componentInstance.idValoracion = this.idValoracion;
    dialogRef.afterClosed().subscribe((result: any) => {
      this.loadTecnicasDiagnosticas();
    });
  }

  /**
   * openAlta: Abre la vista de alta de Técnicas
   */
  openAlta(): void {
    if (this.valoraciones !== undefined) {
      this._loginService.transient = this.valoraciones;
    }
    this._router.navigate(['alta', {idValoracion: this.idValoracion}], { relativeTo: this._route });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.tecnicasDiagnosticas;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    this._loginService.transient = undefined;
    this._querySubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/tecnicasdiagnosticas/tecnicasdiagnosticas.component.ts